<template>
  <header class="sticky-header" id="chat-header">
    <header-top />
    <div class="calc-continer header-2">
      <div class="float-right header-icon-contain col-12-custom">
        <div class="col-2-custom">
          <a
            @click.stop.prevent="$router.go(-1)"
            href="#"
            class="color-red office-location-hide-section"
          >
            <object
              :data="backSvg"
              type="image/svg+xml"
              class="svg-back-arrow"
            ></object>
          </a>
        </div>
        <div class="col-10-custom text-center chat-icon-wrapper">
          <a class="icon-chat-header">
            <img :src="chatIcon" alt="chat-icon" />
          </a>
          <span class="chat-user-name">{{
            groupUsername !== "" ? groupUsername : username
          }}</span>
        </div>
        <!--  <div class="col-4-custom text-right">
          <a href="#" class="color-red"></a>
        </div>-->
      </div>
    </div>
  </header>
</template>

<script>
import HeaderTop from "../common/HeaderTop";
import { nameMixin } from "../../mixins/nameMixin.js";
import { chatUsernameMixin } from "../../mixins/chatUsernameMixin";
import { mapGetters, mapMutations } from "vuex";

export default {
  mixins: [nameMixin, chatUsernameMixin],
  props: {
    groupUsername: String
  },
  data() {
    return {
      backSvg: require("../../assets/svg/back.svg"),
      chatIcon: require("../../assets/img/chat-icon.png")
    };
  },
  computed: {
    ...mapGetters({
      showResultsNow: "getShowResultsNow"
    })
  },
  methods: {
    ...mapMutations({
      preventRemoveResults: "preventRemoveResults"
    })
  },
  components: {
    HeaderTop
  },
  destroyed() {
    if (this.showResultsNow) {
      this.preventRemoveResults();
    }
  }
};
</script>

<style scoped>
header {
  padding-left: 0px !important;
}

.top-extra-45 {
  top: 45px !important;
}

/* .header-icon-contain a.office-location-hide-section {
  line-height: 54px;
} */

.icon-chat-header {
  background-color: #ccc;
  display: inline-table;
  background-color: #ccc;
  display: inline-table;
  width: 25px;
  border-radius: 50px;
}
.icon-chat-header img {
  width: 15px !important;
  margin-top: 1px;
}
.chat-user-name {
  display: block;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.5px;
  margin-top: 6px;
}
.chat-icon-wrapper {
  position: relative;
}
#chat-header .header-2 .col-2-custom {
  width: 30px !important;
  float: left;
  margin-top: 1px;
}
#chat-header .header-2 .col-10-custom.chat-icon-wrapper {
  width: calc(100% - 50px);
  float: left;
  text-align: center;
  padding-right: 5px;
}
#chat-header .header-2 .col-10-custom.chat-icon-wrapper span.chat-user-name {
  display: inline-block;
  padding-left: 10px;
  max-width: 240px;
  max-height: 13px;
  overflow: hidden;
  position: relative;
  top: 1px;
}
</style>
